import { startTransition, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorkspaceContext } from '@/contexts/WorkspaceContext';
import { useOptionalNavigation } from '@/contexts/NavigationContext';
import { clearAccountScopedStorage } from '@/lib/accountScopedStorage';

export const WORKSPACE_SWITCH_LANDING_URL = '/home';

export interface SwitchWorkspaceOptions {
  to?: string;
}

export function useSwitchWorkspace() {
  const { selectedWorkspaceId, setSelectedWorkspaceId } = useWorkspaceContext();
  const navigate = useNavigate();
  const navigation = useOptionalNavigation();

  return useCallback(
    (workspaceId: string | null | undefined, options: SwitchWorkspaceOptions = {}) => {
      if (!workspaceId) return;
      const isSwitch = workspaceId !== selectedWorkspaceId;
      if (!isSwitch && !options.to) return;

      const destination = options.to ?? WORKSPACE_SWITCH_LANDING_URL;
      const run = () => {
        const { pathname, search, hash } = window.location;
        const alreadyThere = `${pathname}${search}${hash}` === destination;
        startTransition(() => {
          if (isSwitch) {
            clearAccountScopedStorage();
            setSelectedWorkspaceId(workspaceId);
          }
          navigate(destination, { replace: alreadyThere });
        });
      };

      if (navigation?.interceptAction) navigation.interceptAction(run);
      else run();
    },
    [selectedWorkspaceId, setSelectedWorkspaceId, navigate, navigation],
  );
}
